export default __webpack_public_path__ + "static/media/cliemenusnd.e3b44eb9.mp3";